module.exports = __webpack_public_path__ + "assets/adpoly-facility-toilets-bulk-upload-template.75f54d04.xlsx";